import CloseIcon from '@mui/icons-material/Close';
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import greenTick from '../../Assets/images/Group 62.png';
import style from './fileupload.module.scss';
import ValidationErrorLabel from '../common/ValidationErrorLabel/ValidationErrorLabel';
import { validationMessages } from '../../utils/constants';

export function FilesAdded({ files, setFiles }) {
  const [error, setError] = useState('');
  const [t] = useTranslation();
  const validationMessage = useMemo(() => validationMessages(t), [t]);
  const onDrop = (e) => {
    e.preventDefault();
    setError(validationMessage.CV_ONLY_ONE_FILE);
  };

  const onDragOver = (e) => e.preventDefault();

  return (
    <div onDrop={onDrop} onDragOver={onDragOver}>
      <div className="mt-5" />
      <div className={`${style.success_zone} pt-3 mt-5 text-center d-block`}>
        <label htmlFor="file_success" className={`${style.fs_label} p-5`}>
          <div className="">{t('profile.builder.start.added')}</div>
          <img src={greenTick} className={`${style.img_upload} pb-2`} alt="file uploaded" />
          {files.map((file) => (
            <div key={file?.lastModified} className="d-flex justify-content-center align-items-center">
              <div key={file?.name} className={style.resume_file_name}>
                {file?.name}
              </div>
              <CloseIcon data-testid="closeBtn" onClick={() => setFiles([])} className={style.cancelBtn} />
            </div>
          ))}
          {error && <ValidationErrorLabel message={error} />}
        </label>
      </div>
    </div>
  );
}
